(() => {
if (window.__paragonB2G1CampaignLoaded) return;
window.__paragonB2G1CampaignLoaded = true;

const campaignAttribute = 'b2g1_campaign';
const higherPriorityPageEnabled = window.ParagonB1G50?.campaignEnabled === true;
const campaignEnabled = window.ParagonB2G1?.campaignEnabled === true && !higherPriorityPageEnabled;
const competingPageEnabled = higherPriorityPageEnabled ||
  ['bra_25', 'set_20'].includes(window.ParagonLeggingBraBundle?.campaign);
const returningCustomer = window.ParagonB2G1?.returningCustomer === true;
const campaignStorageKey = 'paragon_b2g1_campaign_expires_at';
const campaignDurationMs = 2 * 60 * 60 * 1000;
const nativeFetch = window.fetch.bind(window);
let campaignExpiresAt = 0;

function isCartAddRequest(input) {
  const url = input instanceof Request ? input.url : input instanceof URL ? input.toString() : input;
  if (typeof url !== 'string') return false;

  const pathname = new URL(url, window.location.origin).pathname;
  return pathname === '/cart/add' || pathname === '/cart/add.js';
}

async function updateCampaignAttribute(value) {
  await nativeFetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: value === 'true'
      ? { [campaignAttribute]: value, b1g50_campaign: '', legging_bra_bundle_campaign: '' }
      : { [campaignAttribute]: value } }),
  });
}

function getStoredCampaignExpiry(storageKey = campaignStorageKey) {
  try {
    return Number(window.localStorage.getItem(storageKey)) || 0;
  } catch {
    return 0;
  }
}

function storeCampaignExpiry(expiresAt) {
  try {
    window.localStorage.setItem(campaignStorageKey, String(expiresAt));
  } catch {
    // The in-memory expiry still protects the active browser page.
  }
}

function clearCompetingCampaignSessions() {
  try {
    window.localStorage.removeItem('paragon_b1g50_campaign_expires_at');
    window.localStorage.removeItem('paragon_legging_bra_bundle_campaign_expires_at');
    window.localStorage.removeItem('paragon_legging_bra_bundle_campaign');
  } catch {
    // Cart attributes still prevent competing offers when storage is blocked.
  }
}

function clearCampaignSession() {
  campaignExpiresAt = 0;
  try {
    window.localStorage.removeItem(campaignStorageKey);
  } catch {
    // Continue clearing the Shopify cart marker even when storage is blocked.
  }
  document.querySelectorAll('.b2g1-cart-message').forEach((message) => message.remove());
  return updateCampaignAttribute('');
}

if (!returningCustomer && campaignEnabled) {
  campaignExpiresAt = Date.now() + campaignDurationMs;
  storeCampaignExpiry(campaignExpiresAt);
} else if (!returningCustomer && !competingPageEnabled &&
  getStoredCampaignExpiry('paragon_b1g50_campaign_expires_at') <= Date.now()) {
  campaignExpiresAt = getStoredCampaignExpiry();
}

const campaignIsActive = campaignExpiresAt > Date.now();

if (returningCustomer || !campaignIsActive) {
  clearCampaignSession().catch((error) => console.warn('Unable to clear B2G1 campaign.', error));
}

if (campaignIsActive) {
  clearCompetingCampaignSessions();
  // A shopper can add straight from an LP before this request returns. Queue
  // cart-add requests behind it so the Function always receives the marker.
  const campaignActivation = updateCampaignAttribute('true').catch((error) => {
    console.warn('Unable to activate B2G1 campaign.', error);
  });

  window.fetch = (input, init) => {
    if (isCartAddRequest(input)) {
      return campaignActivation.then(() => nativeFetch(input, init));
    }

    return nativeFetch(input, init);
  };

  window.setTimeout(() => {
    clearCampaignSession().catch((error) => console.warn('Unable to expire B2G1 campaign.', error));
  }, campaignExpiresAt - Date.now());
}

document.addEventListener('click', (event) => {
  if (!campaignEnabled || returningCustomer || campaignExpiresAt <= Date.now()) return;

  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

  const destination = new URL(link.href, window.location.origin);
  if (
    destination.origin !== window.location.origin ||
    destination.pathname === window.location.pathname ||
    (destination.hash && destination.pathname === window.location.pathname)
  ) return;

  // Preserve campaign eligibility if a shopper immediately follows a product
  // link from an approved ad landing page.
  event.preventDefault();
  updateCampaignAttribute('true')
    .catch((error) => console.warn('Unable to activate B2G1 campaign.', error))
    .finally(() => window.location.assign(destination.toString()));
}, true);
})();
